import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { useYouTubeIframeApi } from "./useYoutubeIframeApi";

export type EmbeddedYoutubeVideoProps = {
  videoId: string;
  title: string;
  placeholderImageSrc?: string;
  width?: number;
  height?: number;
};

export function EmbeddedYoutubeVideo({ videoId, title, width = 368, height = 284 }: EmbeddedYoutubeVideoProps) {
  const { iframeId, playerIsReady } = useYouTubeIframeApi({
    fullscreenOnPlay: true,
  });

  return (
    <div className="relative rounded-2xl overflow-hidden shrink-0" style={{ aspectRatio: `${width} / ${height}` }}>
      <iframe
        id={iframeId}
        className="w-full h-full absolute top-0 left-0"
        src={`https://www.youtube.com/embed/${videoId}?controls=1&enablejsapi=1`}
        title={title}
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share; fullscreen"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
      {!playerIsReady && (
        <div className="absolute top-0 left-0 w-full h-full">
          <SkeletonLoading showPadding={false} />
        </div>
      )}
    </div>
  );
}
